module.exports = __webpack_public_path__ + "static/img/closeMac1.f00c320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/liveVideo/closeMac1.png
// module id = FnQq
// module chunks = 1